export default __webpack_public_path__ + "static/vid2-ebc500301bb25a880de7cbd3cd51a994.mp4";